import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinkalyancabserviceindombivali() {



    const cardData = {





keyword: "Cab Service in Kalyan",

headingDescription: "Shreesha Tours & Travels offers reliable, affordable, and comfortable Cab Services in Kalyan for local travel, airport transfers, railway station pickup and drop, corporate transportation, one-way cabs, round-trip taxi services, family vacations, pilgrimage tours, sightseeing, and outstation travel across Maharashtra and India. We provide chauffeur-driven Sedan, Swift Dzire, Ertiga, SUV, Innova, Innova Crysta, Tempo Traveller, Urbania, Mini Bus, and luxury vehicles to suit every travel requirement. Our experienced drivers, well-maintained fleet, transparent pricing, doorstep pickup, flexible travel plans, and 24/7 customer support ensure a safe and hassle-free journey. Whether you need a cab for business meetings, weekend getaways, airport transfers, family functions, or long-distance travel, Shreesha Tours & Travels delivers dependable transportation with comfort, punctuality, and professional service.",

topPlaces: [
  {
    title: "Kalyan to Pune",
    description: "Pune is a leading IT and educational hub with destinations like Hinjawadi, Baner, Kharadi, Magarpatta, Wakad, and Pimpri-Chinchwad. It is one of the most booked outstation routes from Kalyan."
  },
  {
    title: "Kalyan to Lonavala",
    description: "Lonavala is famous for Tiger Point, Bhushi Dam, Rajmachi Fort, waterfalls, and lush green valleys. It is an ideal destination for weekend holidays and family trips."
  },
  {
    title: "Kalyan to Mahabaleshwar",
    description: "Mahabaleshwar is known for Venna Lake, Arthur's Seat, strawberry farms, scenic viewpoints, and pleasant weather. It is perfect for couples, families, and nature lovers."
  },
  {
    title: "Kalyan to Shirdi",
    description: "Shirdi is one of India's most popular pilgrimage destinations, attracting devotees visiting the sacred Sai Baba Temple. Comfortable cab services make the journey smooth and convenient."
  },
  {
    title: "Kalyan to Nashik",
    description: "Nashik is famous for Trimbakeshwar Jyotirlinga, Panchavati, vineyards, temples, and industrial areas. It is a preferred destination for business and religious travel."
  },
  {
    title: "Kalyan to Goa",
    description: "Goa is India's favorite beach destination, offering beaches, churches, forts, luxury resorts, nightlife, and water sports. Long-distance cabs provide a comfortable travel experience."
  },
  {
    title: "Kalyan to Alibaug",
    description: "Alibaug is a scenic coastal destination known for beaches, forts, resorts, and peaceful surroundings. It is ideal for weekend vacations and family outings."
  },
  {
    title: "Kalyan to Surat",
    description: "Surat is a major business city known for its diamond and textile industries. Corporate travelers frequently book cabs from Kalyan for business meetings and industrial visits."
  },
  {
    title: "Kalyan to Ahmedabad",
    description: "Ahmedabad is Gujarat's commercial capital with industries, business parks, and heritage attractions. It is a popular destination for both business and leisure travelers."
  },
  {
    title: "Kalyan to Indore",
    description: "Indore is a growing commercial city famous for Rajwada Palace, Sarafa Food Market, and nearby Ujjain. It is a preferred destination for business, family, and religious travel."
  }
],



"services": [
  {
    "name": "Cab Service in Kalyan",
    "description": "Book Cab Service in Kalyan for safe, comfortable, and affordable travel with professional chauffeurs and well-maintained AC vehicles. Choose from Sedan, Ertiga, Innova Crysta, SUV, Kia Carens, and Tempo Traveller options for local rides, airport transfers, railway station pickups, business meetings, family outings, sightseeing tours, and outstation travel with doorstep pickup and 24x7 customer support."
  },
  {
    "name": "Taxi Service in Kalyan",
    "description": "Choose Taxi Service in Kalyan for reliable local and outstation transportation with experienced drivers and clean AC vehicles. Enjoy comfortable travel for office commuting, shopping trips, airport pickup and drop, family functions, corporate travel, hotel transfers, and weekend getaways with transparent pricing and easy online booking."
  },
  {
    "name": "Kalyan Cab Booking",
    "description": "Complete Kalyan Cab Booking online with instant confirmation and multiple vehicle options to match your travel requirements. Reserve Sedan, Ertiga, Innova Crysta, SUV, and premium cabs for airport transfers, local city rides, business travel, family vacations, railway station transfers, and one way or round trip journeys."
  },
  {
    "name": "Kalyan Taxi Service",
    "description": "Hire Kalyan Taxi Service for convenient and dependable transportation with trained chauffeurs and comfortable AC vehicles. Whether you need local travel, airport transfers, corporate transportation, sightseeing, medical visits, or outstation journeys, enjoy punctual service and affordable fares throughout the year."
  },
  {
    "name": "Cab Service in Dombivali",
    "description": "Book Cab Service in Dombivali for fast, safe, and comfortable transportation with professional drivers and well-maintained AC cars. Our cab service is ideal for local travel, airport transfers, railway station pickups, family trips, office commuting, hotel transfers, and outstation travel with flexible booking options."
  },
  {
    "name": "Taxi Service in Dombivali",
    "description": "Choose Taxi Service in Dombivali for affordable and reliable transportation with experienced chauffeurs and clean vehicles. Enjoy hassle-free travel for daily commuting, business meetings, shopping, airport transfers, family functions, tourist attractions, and long-distance journeys with transparent pricing."
  },
  {
    "name": "Dombivali Cab Booking",
    "description": "Complete Dombivali Cab Booking with instant online reservations, quick confirmation, and a wide range of chauffeur-driven vehicles. Select Sedan, Ertiga, Innova Crysta, SUV, or Tempo Traveller for local travel, airport transfers, business trips, sightseeing, and outstation travel at competitive prices."
  },
  {
    "name": "Dombivali Taxi Service",
    "description": "Hire Dombivali Taxi Service for smooth and comfortable travel with experienced drivers and premium AC vehicles. Whether you require local transportation, corporate travel, airport pickup and drop, railway station transfers, or family vacations, our taxi service ensures timely and dependable journeys."
  },
  {
    "name": "Kalyan Dombivali Cab Service",
    "description": "Book Kalyan Dombivali Cab Service for reliable transportation across Kalyan, Dombivali, Mumbai, Navi Mumbai, and outstation destinations. Enjoy chauffeur-driven AC vehicles, affordable fares, flexible booking options, and comfortable travel for business, family, airport, and leisure trips."
  },
  {
    "name": "Kalyan Outstation Cab",
    "description": "Reserve Kalyan Outstation Cab for one way and round trip travel to destinations across Maharashtra, Goa, Gujarat, Karnataka, and other states. Travel comfortably with Sedan, Ertiga, Innova Crysta, SUV, and Tempo Traveller vehicles driven by experienced chauffeurs offering safe, reliable, and affordable long-distance transportation."
  },
  {
    "name": "Dombivali Outstation Taxi",
    "description": "Choose Dombivali Outstation Taxi for convenient long-distance travel with professional drivers, clean AC vehicles, and transparent pricing. Ideal for family holidays, business travel, pilgrimages, weekend trips, and corporate journeys with flexible one way and round trip booking options."
  },
  {
    "name": "Kalyan Airport Taxi",
    "description": "Book Kalyan Airport Taxi for timely airport pickup and drop services to Mumbai International and Domestic Airports. Benefit from flight tracking, experienced chauffeurs, luggage assistance, doorstep pickup, comfortable vehicles, and 24x7 airport transportation for business and leisure travelers."
  },
  {
    "name": "Dombivali Airport Cab",
    "description": "Reserve Dombivali Airport Cab for dependable airport transfers with punctual chauffeurs and comfortable AC vehicles. Enjoy smooth travel to and from Mumbai Airport with affordable fares, flight monitoring, professional service, and convenient pickup from your home, office, hotel, or railway station."
  },
  {
    "name": "Kalyan One Way Cab",
    "description": "Choose Kalyan One Way Cab for affordable single-trip transportation without paying return charges. Our one way cab service offers fixed pricing, clean vehicles, experienced drivers, doorstep pickup, and comfortable travel for airport transfers, business visits, and intercity journeys."
  },
  {
    "name": "Dombivali Round Trip Taxi",
    "description": "Book Dombivali Round Trip Taxi for convenient return travel with flexible schedules and customized packages. Perfect for family vacations, business tours, religious trips, sightseeing, weekend getaways, and outstation travel with professional chauffeurs and well-maintained AC vehicles."
  },
  {
    "name": "Best Cab Service Kalyan Dombivali",
    "description": "Choose the Best Cab Service Kalyan Dombivali for premium travel with experienced drivers, well-maintained AC vehicles, transparent pricing, and excellent customer support. We provide reliable local, airport, corporate, family, sightseeing, and outstation transportation with Sedan, Ertiga, Innova Crysta, SUV, Kia Carens, and Tempo Traveller options available 24x7."
  }
],
"tableData": [
  ["Cab Service in Kalyan", "Taxi Service in Kalyan"],
  ["Kalyan Cab Booking", "Kalyan Taxi Service"],
  ["Cab Service in Dombivali", "Taxi Service in Dombivali"],
  ["Dombivali Cab Booking", "Dombivali Taxi Service"],
  ["Kalyan Dombivali Cab Service", "Kalyan Outstation Cab"],
  ["Dombivali Outstation Taxi", "Kalyan Airport Taxi"],
  ["Dombivali Airport Cab", "Kalyan One Way Cab"],
  ["Dombivali Round Trip Taxi", "Best Cab Service Kalyan Dombivali"]
],




whychoose: [
  {
    WhyChooseheading: "Reliable Cab Service in Kalyan & Dombivli",
    WhyChoosedescription: "Shreesha Travels offers dependable cab services in Kalyan and Dombivli for local commuting, airport transfers, corporate travel, family outings, sightseeing, and outstation journeys. Our focus is on providing comfortable rides with professional chauffeurs and well-maintained vehicles."
  },
  {
    WhyChooseheading: "Travel Solutions Designed Around Your Schedule",
    WhyChoosedescription: "Whether you need an early morning airport transfer, a late-night pickup, a business trip, or a weekend getaway, our flexible taxi services are available to match your travel plans."
  },
  {
    WhyChooseheading: "Comfortable Vehicles for Every Type of Journey",
    WhyChoosedescription: "Book Hatchbacks, Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, SUVs, Luxury Cars, Tempo Travellers, and Mini Buses for individual travellers, families, corporate teams, and group travel."
  },
  {
    WhyChooseheading: "Direct Airport & Intercity Taxi Services",
    WhyChoosedescription: "Reserve cabs from Kalyan or Dombivli to Mumbai Airport, Navi Mumbai, Pune, Lonavala, Nashik, Shirdi, Surat, Ahmedabad, Goa, Kolhapur, and many other destinations across India."
  },
  {
    WhyChooseheading: "Ideal for Business, Leisure & Special Events",
    WhyChoosedescription: "Our taxi services are suitable for office travel, conferences, client meetings, wedding transportation, educational tours, religious trips, and holiday vacations throughout the year."
  },
  {
    WhyChooseheading: "Professional Chauffeurs with Regional Expertise",
    WhyChoosedescription: "Experienced drivers are familiar with Kalyan, Dombivli, Mumbai, Navi Mumbai, major highways, and popular travel routes, ensuring safe and timely transportation."
  },
  {
    WhyChooseheading: "Flexible Booking Options for Every Traveller",
    WhyChoosedescription: "Choose one-way cabs, round-trip journeys, full-day rentals, airport transfers, multi-day tours, or customized travel itineraries according to your requirements."
  },
  {
    WhyChooseheading: "Experience Dependable Service with Shreesha Travels",
    WhyChoosedescription: "Transparent pricing, responsive customer assistance, and a commitment to quality make us a preferred choice for cab services in Kalyan and Dombivli."
  }
]

};

const faqData = [
  {
    question: "Do you provide cab services throughout Kalyan and Dombivli?",
    answer: "Yes, our taxi services are available across Kalyan, Dombivli, nearby residential areas, business locations, railway stations, and surrounding suburbs."
  },
  {
    question: "Can I book a cab from Kalyan or Dombivli to Mumbai Airport?",
    answer: "Yes, we provide scheduled airport transfers with convenient pickup and drop services."
  },
  {
    question: "Which destinations are frequently booked from Kalyan and Dombivli?",
    answer: "Popular routes include Pune, Lonavala, Shirdi, Nashik, Mahabaleshwar, Goa, Surat, Ahmedabad, Kolhapur, and several other cities."
  },
  {
    question: "Are taxis available for corporate employees and office travel?",
    answer: "Yes, we provide transportation for business meetings, employee travel, executive transfers, conferences, and corporate events."
  },
  {
    question: "Can I reserve a taxi for multiple days?",
    answer: "Yes, customized multi-day travel packages are available for vacations, pilgrimages, business tours, and family trips."
  },
  {
    question: "Which vehicle is recommended for larger families?",
    answer: "Innova, Innova Crysta, SUVs, Tempo Travellers, and Mini Buses are excellent options for larger groups with additional luggage."
  },
  {
    question: "Do you provide taxis for weddings and family functions?",
    answer: "Yes, transportation can be arranged for weddings, receptions, engagements, celebrations, and other special occasions."
  },
  {
    question: "Can I include multiple pickup and drop locations in one booking?",
    answer: "Yes, customized travel routes with multiple stops can be planned according to your itinerary."
  },
  {
    question: "How is the taxi fare calculated?",
    answer: "The fare depends on the selected vehicle, travel distance, booking duration, route, and any additional travel requirements."
  },
  {
    question: "How do I book a cab service in Kalyan or Dombivli with Shreesha Travels?",
    answer: "Share your pickup location, destination, travel date, passenger count, and preferred vehicle to receive a personalized quotation and instant booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Akshay Bhise",
    feedback: "Excellent time management and courteous service made the journey extremely comfortable. The vehicle was in great condition, and the overall travel experience was seamless.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Rupal Merchant",
    feedback: "Every aspect of the trip was well organized, from booking assistance to the final drop-off. The comfortable ride and professional chauffeur made the journey truly enjoyable.",
    rating: 5
  }
];














    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Kalyan / Cab Service in Dombivali",
  "image": "https://www.shreeshatravels.com/assets/images/cab-service-in-kalyan-dombivali.webp",
  "description":
    "Book Cab Service in Kalyan and Dombivali with Shreesha Tours & Travels for safe, comfortable, and affordable local and outstation taxi services. We provide Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for airport transfers, corporate travel, business meetings, family trips, sightseeing, and intercity travel with experienced chauffeurs.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/cab-service-in-kalyan-dombivali"
  }
};




    return (
        <div>
<Helmet>
  <title>Cab Service in Kalyan & Dombivali | Local & Outstation Cabs | +91 8355835813</title>

  <meta
    name="description"
    content="Book Cab Service in Kalyan and Dombivali with Shreesha Travels for reliable local, airport, and outstation taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta with affordable fares and 24x7 online booking."
  />

  <meta
    name="keywords"
    content="Cab Service in Kalyan, Taxi Service in Kalyan, Kalyan Cab Booking, Kalyan Taxi Service, Cab Service in Dombivali, Taxi Service in Dombivali, Dombivali Cab Booking, Dombivali Taxi Service, Kalyan Outstation Cab, Dombivali Airport Cab, Online Cab Booking Kalyan, Online Cab Booking Dombivali"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/47.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Cabserviceinkalyancabserviceindombivali;